export default {
  purchase: [],
  failPurchase: [],
  purchaseById : {
    PONumber:"",
    updatedAt:"",
    deliveryDate:"",
    sapSo:"",
    orderStatus:"",
    customerPO:"",
    items:[],
    customerDetail:{
      type:"",
      companyName:"",
      firstName:"",
      lastName:"",
      phone:""
    },
    dealer:{
      dealerName:""
    },
    gstCalculation:{
      total:0,
      gst:0,
      grandTotal:0
    }
  },

  ekioskDashboardField:[],
  ekioskDashboardData:[],
  kioskPassword:{},
  kioskExpiry:{}
}
